import { IContactForm } from "store/entities/contact-forms/interfaces";

export type ValidationResult = { type: "ok" } | { type: "required" } | { type: "length"; limit: number };

export function validate(fieldName: keyof IContactForm, value: string): ValidationResult {
  if (value.trim().length === 0) {
    return { type: "required" };
  }

  if (["nameLabel", "messageLabel", "subjectLabel", "emailLabel", "header"].includes(fieldName) && value.length > 80) {
    return { type: "length", limit: 80 };
  }

  if (
    [
      "name",
      "caption",
      "confirmation",
      "nameRequiredError",
      "subjectRequiredError",
      "emailInvalidError",
      "emailRequiredError",
      "subjectRequiredError",
      "consentRequiredError",
      "messageRequiredError",
      "sendErrorMessage",
    ].includes(fieldName) &&
    value.length > 200
  ) {
    return { type: "length", limit: 200 };
  }

  if (
    ["sendLabel", "sendErrorLabel", "sendSuccessLabel", "sendLoadingLabel"].includes(fieldName) &&
    value.length > 40
  ) {
    return { type: "length", limit: 40 };
  }

  if (fieldName === "consentMessage" && value.length > 800) {
    return { type: "length", limit: 800 };
  }

  return { type: "ok" };
}
